import React from 'react';
import './style.css';
import { BUTTON_TYPE } from '../../../constants/constant';
import { t } from '../../../translation/translation';

type TButtonProps = {
  iconLeft?: string,
  onClick?: () => void,
  label?: string,
  type?: keyof typeof BUTTON_TYPE,
  htmlType?: 'button' | 'submit' | 'reset'
  disabled?: boolean
}

export const Button = ({
  iconLeft,
  onClick,
  label = "button",
  type = BUTTON_TYPE.PRIMARY,
  htmlType = 'button',
  disabled = false,
}: TButtonProps): JSX.Element => {
  return (
    <button type={htmlType} className={`btn btn--${type.toLowerCase()}`} onClick={onClick} disabled={disabled}>
      {iconLeft && <img src={iconLeft} alt="Icon" className="btn-icon icon-left" />}
      <h5 className={'btn-text'}>{t(label)}</h5>
    </button>
  );
}
